import { useState, useEffect} from "react";
import { Button , CircularProgress, Box} from "@mui/material";
import {useNavigate } from "react-router-dom";
import Auth from "../Auth/Auth";
import PaymentSuccessPopup from "../PaymentSuccessPopup/PaymentSuccessPopup";
import ImageCaptcha from '../Captcha/ImageCaptcha';
import { createSubscription } from "../../services/razorpayService";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constants/Constants";
import axiosInstance from "../../services/axiosInstance";

function RazorpayButton({ subscriptionPlan, customer , userData, start_at }) {
  const navigate =useNavigate();
  const [loading, setLoading] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const [captchaVerified, setCaptchaVerified] = useState(false); 

  const user_id = localStorage.getItem("user_id") || userData.userId;
  const {isLoggedIn } = Auth();



  // useEffect(() => {
  //   const existing = document.getElementById("razorpay-script");

  // if (!existing) {
  //   const script = document.createElement("script");
  //   script.id = "razorpay-script";
  //   script.src = "https://checkout.razorpay.com/v1/checkout.js";
  //   script.async = true;
  //   document.body.appendChild(script);
  // } 
  // }, []);

  const loadRazorpay = async () => {
    setLoading(true);
    try {
      const data = await createSubscription(subscriptionPlan.id, customer, user_id, start_at, userData  );
      setLoading(false);

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        subscription_id: data.subscription.id,
        name: "PHYtool",
        description: `Subscription for ${subscriptionPlan.id}`,
        handler: async function (response) {
          try {
            await axiosInstance.post(`${BASE_URL}/razorpay/verify-and-save`, {
              ...response,
              subscription_Id: data.subscription.id,
              user_id,
            });

            if (isLoggedIn) {
              navigate('/mysubscription', { state: { paymentResponse: response } })
            } else {
              setSuccessData({ customer, subscriptionPlan });
            }
          }

        catch (error) {
            console.error("Error verifying payment:", error);
            toast.error("Payment verification failed. Please contact support.")

          }

        },
        prefill: {
          name: customer.firstName,
          email: customer.email,
          contact: 9192345234,
        },
        theme: { color: "#7F141A" },
      };

      const rzp1 = new window.Razorpay(options);

      rzp1.open();

    } catch (error) {
      console.error("Subscription error:", error);
      toast.error("Failed to initiate subscription. Please try again.");
    }

  };



  return (
    <>
    <Box sx={{ mb: 2 }}>
        <ImageCaptcha onSuccess={() => setCaptchaVerified(true)} onFailure={() => setCaptchaVerified(false)} />
    </Box>

    <Button variant="contained" onClick={loadRazorpay} style={{ width: "100%" }}  disabled={!captchaVerified || loading} >
      {loading ? <CircularProgress size={24} color="inherit" /> : "Pay Now"}
    </Button>
    {successData && (
        <PaymentSuccessPopup open={true} onClose={() => setSuccessData(null)} customer={successData.customer} subscriptionPlan={successData.subscriptionPlan}/>
      )}
    </>

  );

}



export default RazorpayButton;

